module.exports = __webpack_public_path__ + "static/media/node.d42672d4.png";